// Relative centrifugal force (RCF / "g force") ⇄ rotor speed (RPM).
// Standard relation: RCF = 1.118 × 10⁻⁵ × r × N²
//   r = rotor radius in centimetres, N = speed in revolutions per minute.

const K = 1.118e-5;

/** RCF (× g) from rotor radius (cm) and speed (RPM). Null on invalid input. */
export function rcfFromRpm(radiusCm: number, rpm: number): number | null {
  if (!Number.isFinite(radiusCm) || !Number.isFinite(rpm)) return null;
  if (radiusCm <= 0 || rpm < 0) return null;
  return K * radiusCm * rpm ** 2;
}

/** Speed (RPM) from rotor radius (cm) and RCF (× g). Null on invalid input. */
export function rpmFromRcf(radiusCm: number, rcf: number): number | null {
  if (!Number.isFinite(radiusCm) || !Number.isFinite(rcf)) return null;
  if (radiusCm <= 0 || rcf < 0) return null;
  return Math.sqrt(rcf / (K * radiusCm));
}
